import { useQuery } from '@tanstack/react-query';

import { addonList } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { queryKeys } from '../query-keys';

// Backs the sidebar switcher. Uses lightweight view=switcher (launchable addons
// only) to stay cheap. No polling; child of the list key, so mutations refresh it.
export function useAddonSwitcher() {
  return useQuery({
    queryKey: queryKeys.switcher(),
    queryFn: getSwitcherAddons,
    ...withError('Unable to load add-ons'),
  });
}

async function getSwitcherAddons() {
  const { data } = await addonList({ query: { view: 'switcher' } });
  return data;
}
